import React from "react";
import { useTranslation } from "react-i18next";
import SunEditor from "suneditor-react";
import "../../../assets/style/featuresStyle/editorText.scss";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import { instance } from "../../../services/configApi";
import { Await } from "react-router-dom";

const EditorText = ({ setText, text, type, height = 300, placeholder }) => {
  const { t } = useTranslation();
  const handleImageUploadBefore = (files, info, uploadHandler) => {
    try {
      const formData = new FormData();
      formData.append("file", files[0]);
      instance
        .post("/image/upload", formData, {
          headers: {
            "Content-type": "multipart/form-date",
          },
        })
        .then((res) => {
          const response = {
            result: [
              {
                url: `${window.SERVER_URL}/${res.data.data}`,
                name: files[0].name,
                size: files[0].size,
              },
            ],
          };
          return uploadHandler(response);
        });
    } catch (error) {}
  };
  return (
    <div
      className={`boxEditText ${type}`}
      style={type === "checkEmptyText" ? { border: "1px solid red" } : null}
    >
      <SunEditor
        placeholder={t(placeholder)}
        onImageUploadBefore={handleImageUploadBefore}
        hideToolbar={!setText ? true : false}
        disable={!setText ? true : false}
        onChange={(e) =>
          setText
            ? setText((pre) => {
                return {
                  ...pre,
                  content: e,
                };
              })
            : null
        }
        onSetToolbarButtons={[]}
        setContents={
          text
            // ? text.replace(
            //     new RegExp(window.SERVER_CLIENT_URL, "g"),
            //     window.SERVER_URL
            //   )
            // : ""
        }
        setOptions={{
          minHeight: height,
          maxHeight: height,
          buttonList: [
            /** command */
            [
              "blockquote",
              /** Submenu */
              "align",
              "font",
              "fontColor",
              "fontSize",
              "formatBlock",
              "hiliteColor",
              "horizontalRule",
              "lineHeight",
              "list",
              "paragraphStyle",
              "table",
              "template",
              "textStyle",
              /** Dialog */
              "image",
              "link",
              "video",
              "audio",
              // "math", // You must add the 'katex' library at options to use the 'math' plugin.
              /** File browser */
              // You must add the "imageGalleryUrl".
              // A button is added to the image modal.
              // You can also use image gallery by adding it directly to the button list. (You must add "image" plugin.)
              // "imageGallery"
            ],
          ], // Or Array of button list, eg. [['font', 'align'], ['image']]
          // plugins: [font] set plugins, all plugins are set by default
          // Other option
        }}
      />
    </div>
  );
};
export default EditorText;
